(function () {
  const STORAGE_KEY = "zenzoone_age_verified_at";
  const REMEMBER_DAYS = 30;
  const EXIT_URL = "https://www.google.com";
  const LOGO_FILE = "LOGO-W.webp";
  const LOGO_URL = getAssetUrl(LOGO_FILE);
  const COPY = getLocalizedCopy();

  function getLocalizedCopy() {
    const lang = ((navigator.languages && navigator.languages[0]) || navigator.language || "en").toLowerCase();

    if (lang.startsWith("de")) {
      return {
        title: "Altersverifikation",
        body: "Diese Website enthaelt Produkte fuer Erwachsene und ist ausschliesslich fuer Erwachsene bestimmt. Bitte bestaetigen Sie, dass Sie mindestens 18 Jahre alt sind, um fortzufahren.",
        confirm: "Ich bin 18 Jahre oder aelter",
        exit: "Ich bin unter 18",
        note: `Ihre Auswahl wird auf diesem Geraet ${REMEMBER_DAYS} Tage lang gespeichert.`
      };
    }

    if (lang.startsWith("fr")) {
      return {
        title: "Verification de l'age",
        body: "Ce site contient des produits pour adultes et s'adresse uniquement aux adultes. Veuillez confirmer que vous avez au moins 18 ans pour continuer.",
        confirm: "J'ai 18 ans ou plus",
        exit: "J'ai moins de 18 ans",
        note: `Votre choix sera memorise sur cet appareil pendant ${REMEMBER_DAYS} jours.`
      };
    }

    if (lang.startsWith("es")) {
      return {
        title: "Verificacion de edad",
        body: "Este sitio contiene productos para adultos y esta destinado unicamente a adultos. Confirma que tienes al menos 18 anos para continuar.",
        confirm: "Tengo 18 anos o mas",
        exit: "Soy menor de 18 anos",
        note: `Tu eleccion se recordara en este dispositivo durante ${REMEMBER_DAYS} dias.`
      };
    }

    if (lang.startsWith("it")) {
      return {
        title: "Verifica dell'eta",
        body: "Questo sito contiene prodotti per adulti ed e destinato esclusivamente a un pubblico adulto. Conferma di avere almeno 18 anni per continuare.",
        confirm: "Ho almeno 18 anni",
        exit: "Ho meno di 18 anni",
        note: `La tua scelta sara ricordata su questo dispositivo per ${REMEMBER_DAYS} giorni.`
      };
    }

    return {
      title: "Age Verification",
      body: "This site contains adult products and is intended for adults only. Please confirm that you are at least 18 years old to continue.",
      confirm: "I am 18 or older",
      exit: "I am under 18",
      note: `Your choice will be remembered on this device for ${REMEMBER_DAYS} days.`
    };
  }

  function getAssetUrl(fileName) {
    const currentScript = document.currentScript;
    if (currentScript && currentScript.src) {
      return new URL(fileName, currentScript.src).href;
    }

    return fileName;
  }

  function isCheckoutPage() {
    const href = window.location.href.toLowerCase();
    const path = window.location.pathname.toLowerCase();
    return path.includes("/checkout") || href.includes("checkout");
  }

  function isVerified() {
    const savedAt = Number(localStorage.getItem(STORAGE_KEY));
    if (!savedAt) return false;

    const maxAge = REMEMBER_DAYS * 24 * 60 * 60 * 1000;
    return Date.now() - savedAt < maxAge;
  }

  function saveVerified() {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  function unlockPage() {
    document.documentElement.classList.remove("zz-age-gate-prelock");
    document.documentElement.classList.remove("zz-age-gate-locked");
    if (document.body) {
      document.body.classList.remove("zz-age-gate-locked");
    }
  }

  function removeAgeGate() {
    const gate = document.getElementById("zz-age-gate");
    if (gate) gate.remove();
    unlockPage();
  }

  function ensureStyle() {
    if (document.getElementById("zz-age-gate-style")) return;

    const style = document.createElement("style");
    style.id = "zz-age-gate-style";
    style.textContent = `
      html.zz-age-gate-locked,
      body.zz-age-gate-locked{
        overflow:hidden !important;
      }

      #zz-age-gate{
        position:fixed;
        inset:0;
        z-index:2147483647;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:20px;
        background:rgba(0,0,0,.72);
        font-family:var(--font-body-family), Arial, sans-serif;
      }

      #zz-age-gate,
      #zz-age-gate *{
        box-sizing:border-box;
      }

      .zz-age-card{
        width:100%;
        max-width:430px;
        background:#fff;
        color:#111;
        border-radius:18px;
        padding:0 24px 22px;
        box-shadow:0 18px 60px rgba(0,0,0,.28);
        text-align:center;
        overflow:hidden;
      }

      .zz-age-logo-wrap{
        width:calc(100% + 48px);
        height:132px;
        margin:0 -24px 24px;
        display:flex;
        align-items:center;
        justify-content:center;
        background:#000;
        overflow:hidden;
      }

      .zz-age-logo{
        width:116px;
        height:116px;
        object-fit:contain;
        display:block;
      }

      .zz-age-title{
        margin:0 0 12px;
        font-family:var(--font-heading-family), var(--font-body-family), Arial, sans-serif;
        font-size:26px;
        line-height:1.2;
        font-weight:800;
      }

      .zz-age-copy{
        margin:0 0 22px;
        color:#444;
        font-size:15px;
        line-height:1.55;
      }

      .zz-age-actions{
        display:flex;
        flex-direction:column;
        gap:10px;
      }

      .zz-age-btn{
        width:100%;
        min-height:48px;
        border-radius:12px;
        border:1px solid #111;
        cursor:pointer;
        font-size:15px;
        font-weight:800;
      }

      .zz-age-confirm{
        background:#111;
        color:#fff;
      }

      .zz-age-exit{
        background:#fff;
        color:#111;
      }

      .zz-age-note{
        margin:16px 0 0;
        color:#666;
        font-size:12px;
        line-height:1.45;
      }

      @media (max-width:480px){
        #zz-age-gate{
          padding:14px;
        }

        .zz-age-card{
          padding:0 18px 20px;
          border-radius:16px;
        }

        .zz-age-logo-wrap{
          width:calc(100% + 36px);
          height:110px;
          margin:0 -18px 22px;
        }

        .zz-age-logo{
          width:92px;
          height:92px;
        }

        .zz-age-title{
          font-size:23px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function createAgeGate() {
    if (isCheckoutPage() || isVerified()) {
      unlockPage();
      return;
    }

    if (document.getElementById("zz-age-gate")) return;

    document.documentElement.classList.add("zz-age-gate-locked");
    document.documentElement.classList.add("zz-age-gate-prelock");
    document.body.classList.add("zz-age-gate-locked");
    ensureStyle();

    const gate = document.createElement("div");
    gate.id = "zz-age-gate";
    gate.setAttribute("role", "dialog");
    gate.setAttribute("aria-modal", "true");
    gate.setAttribute("aria-labelledby", "zz-age-title");
    gate.innerHTML = `
      <div class="zz-age-card">
        <div class="zz-age-logo-wrap">
          <img class="zz-age-logo" src="${LOGO_URL}" alt="Zenzoone">
        </div>
        <h2 id="zz-age-title" class="zz-age-title">${COPY.title}</h2>
        <p class="zz-age-copy">${COPY.body}</p>
        <div class="zz-age-actions">
          <button type="button" class="zz-age-btn zz-age-confirm">${COPY.confirm}</button>
          <button type="button" class="zz-age-btn zz-age-exit">${COPY.exit}</button>
        </div>
        <p class="zz-age-note">${COPY.note}</p>
      </div>
    `;
    document.body.appendChild(gate);

    const confirmBtn = gate.querySelector(".zz-age-confirm");
    const exitBtn = gate.querySelector(".zz-age-exit");

    confirmBtn.addEventListener("click", function () {
      confirmBtn.disabled = true;
      saveVerified();
      removeAgeGate();
    });

    exitBtn.addEventListener("click", function () {
      exitBtn.disabled = true;
      window.location.href = EXIT_URL;
    });
  }

  if (document.body) {
    createAgeGate();
  } else {
    document.addEventListener("DOMContentLoaded", createAgeGate);
  }
})();